import axios from "axios"
import router from "@/router"
import { sessionState } from "@/state"


const watchers = {}

class ApiClient {
    baseUrl = null

    constructor(baseUrl) {
        this.baseUrl = baseUrl
        this._client = axios.create({
            baseURL: baseUrl,
        })

        this._client.interceptors.request.use(config => {
            if (sessionState.session?.webSessionId) {
                config.headers["X-Web-Session-Id"] = sessionState.session?.webSessionId
            }
            config.headers["time-zone"] = Intl.DateTimeFormat().resolvedOptions().timeZone

            return config
        })

        this._client.interceptors.response.use(response => {
            return response
        }, error => {
            // TODO: make this prettier
            if (error.response?.data?.code === "session_invalid") {
                setTimeout(() => router.push({ name: "sessionInvalid" }))
            }
            throw error
        })
    }

    ignoreResourceNotFound(err) {
        if (!err.response) {
            throw err
        }

        if (err.response.status !== 404) {
            throw err
        }

        if (!err.response.data) {
            throw err
        }

        if (err.response.data.code !== "resource_not_found") {
            throw err
        }

        return null
    }

    valueOnStatus

    get(url, params) {
        let doRequest = () => {
            return this._client.get(url, { params }).then(this._transformResponse)
        }

        let promise = doRequest()

        if (params && params.disableErrorHandling) {
            return promise
        }

        return promise.catch(this._handleError(doRequest))
    }

    put(url, body, params) {
        let doRequest = () => {
            return this._client.put(url, body, { params }).then(this._transformResponse)
        }

        let promise = doRequest()

        if (params && params.disableErrorHandling) {
            return promise
        }

        return promise.catch(this._handleError(doRequest))
    }

    post(url, body, params) {
        let doRequest = () => {
            return this._client.post(url, body, { params }).then(this._transformResponse)
        }

        let promise = doRequest()

        if (params && params.disableErrorHandling) {
            return promise
        }

        return promise.catch(this._handleError(doRequest))
    }

    patch(url, body, params) {
        let doRequest = () => {
            return this._client.patch(url, body, { params }).then(this._transformResponse)
        }

        let promise = doRequest()

        if (params && params.disableErrorHandling) {
            return promise
        }

        return promise.catch(this._handleError(doRequest))
    }

    delete(url, params) {
        let doRequest = () => {
            return this._client.delete(url, { params })
        }

        let promise = doRequest()

        if (params && params.disableErrorHandling) {
            return promise
        }

        return promise.catch(this._handleError(doRequest))
    }

    _handleError(retryFn) {
        return error => {
            if (!error.response || error.response.status !== 401) {
                return Promise.reject(error)
            }

            return Promise.reject(error)
        }
    }

    _transformResponse(response) {
        return response.data
    }

    static watch(service) {
        return () => {
            let watcher = watchers[service]
            if (!watcher) watcher = watchers[service] = new Watcher(service)
            return watcher.invoke()
        }
    }
}

// class Watcher {
//
//     constructor(service) {
//         this.service = service
//         this.url = ''
//         this.api = null
//     }
//
//     invoke() {
//         const url = session.services[this.service] || ''
//
//         if (!this.api || this.url !== url) {
//             this.api = new ApiService(url)
//             this.url = url
//         }
//
//         return this.api
//     }
//
//
// }

export default ApiClient
